var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRecruitment3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84,
    height: 80,
    viewBox: "0 0 84 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_31724",
    "data-name": "\\uC0AC\\uAC01\\uD615 31724",
    width: 84,
    height: 80,
    transform: "translate(1308 4523)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_31725",
    "data-name": "\\uC0AC\\uAC01\\uD615 31725",
    width: 68.626,
    height: 76.39,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_666",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 666",
    transform: "translate(-1308 -4523)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1208",
    "data-name": "\\uADF8\\uB8F9 1208",
    transform: "translate(1315.687 4524.803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1207",
    "data-name": "\\uADF8\\uB8F9 1207",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_756",
    "data-name": "\\uD328\\uC2A4 756",
    d: "M64.06,47.172H39.352V44.543a9.526,9.526,0,0,1,9.449-9.6h5.809a9.526,9.526,0,0,1,9.449,9.6Z",
    transform: "translate(-1.554 -0.847)",
    fill: "none",
    stroke: "#fefeff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_757",
    "data-name": "\\uD328\\uC2A4 757",
    d: "M58.377,24.219a6.772,6.772,0,1,1-6.772-6.879A6.826,6.826,0,0,1,58.377,24.219Z",
    transform: "translate(-1.771 -0.42)",
    fill: "none",
    stroke: "#fefeff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_758",
    "data-name": "\\uD328\\uC2A4 758",
    d: "M26.6,76.214H1.9V73.585a9.526,9.526,0,0,1,9.449-9.6h5.809a9.526,9.526,0,0,1,9.449,9.6Z",
    transform: "translate(-0.075 -1.551)",
    fill: "none",
    stroke: "#fefeff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_759",
    "data-name": "\\uD328\\uC2A4 759",
    d: "M20.922,53.262a6.772,6.772,0,1,1-6.772-6.879A6.826,6.826,0,0,1,20.922,53.262Z",
    transform: "translate(-0.292 -1.125)",
    fill: "none",
    stroke: "#fefeff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_172",
    "data-name": "\\uC120 172",
    x1: 11.464,
    transform: "translate(9.672 9.247)",
    fill: "none",
    stroke: "#fefeff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_173",
    "data-name": "\\uC120 173",
    x1: 8.389,
    transform: "translate(9.672 15.506)",
    fill: "none",
    stroke: "#fefeff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_760",
    "data-name": "\\uD328\\uC2A4 760",
    d: "M31.062,20.5l3.218,2.778a.854.854,0,0,1-.54,1.5H4.366A3.4,3.4,0,0,1,1,21.343V3.828A2.8,2.8,0,0,1,3.772,1H26.188a2.912,2.912,0,0,1,2.882,2.9l.183,12.7A5.252,5.252,0,0,0,31.062,20.5Z",
    transform: "translate(-0.039 -0.024)",
    fill: "none",
    stroke: "#fefeff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_761",
    "data-name": "\\uD328\\uC2A4 761",
    d: "M18.257,47.807H66.222a2.194,2.194,0,0,1,2.164,2.222V77.872",
    transform: "translate(-0.721 -1.481)",
    fill: "none",
    stroke: "#fefeff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_174",
    "data-name": "\\uC120 174",
    x2: 40.102,
    transform: "translate(26.53 70.276)",
    fill: "none",
    stroke: "#fefeff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecruitment3);
export default __webpack_public_path__ + "static/media/icon_recruitment_3.7b411671fcc8f653f01a743a89274b21.svg";
export { ForwardRef as ReactComponent };